import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import './components.css';
import { useNavigate } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;


const AuthForm = ({ onLoginSuccess }) => {
    const [isLogin, setIsLogin] = useState(true);
    const [passwordError, setPasswordError] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
const navigate = useNavigate();
    const toggleAuthMode = () => {
        setIsLogin((prevState) => !prevState);
    };

    const handleEmailChange = (value) => {
        setEmail(value.trim());
    };

    const handlePasswordChange = (value) => {
        setPassword(value);
    };

    const handleProcess = async() => {
        setIsLoading(true);
        setErrorMessage(''); // Clear previous error message
        const Logindata = {
            Email: email,
            Password: password,
            RememberMe: false,
        };

        const url = `${BASE_URL}api/UserAccount/Login`;

            try {
        const result = await axios.post(url, Logindata);
        setIsLoading(false);

        if (result.data.success) {
            const role = result.data.role || result.data.roles;
            onLoginSuccess(result.data.email, role);
            navigate('/overview');
        } else {
            setErrorMessage('Wrong credentials, please try again.');
        }
    } catch (error) {
        setIsLoading(false);
        setErrorMessage('Login failed. Please try again.');
    }

    };

    return (
        <div className="authform-container">
            <header className="d-flex justify-content-between align-items-center p-3">
                <h1 className="logo"></h1>
                {/*<nav className="d-flex align-items-center">*/}
                {/*    <a href="#home" className="nav-link">Home</a>*/}
                {/*    <a href="#course" className="nav-link">Course</a>*/}
                {/*    <a href="#contact" className="nav-link">Contact</a>*/}
                {/*    <a href="#about" className="nav-link">About</a>*/}
                {/*    <div className="search-container">*/}
                {/*        <input type="text" placeholder="Search" className="search-input" />*/}
                {/*        <i className="bi bi-search"></i>*/}
                {/*    </div>*/}
                {/*    <button className="btn btn-dark ms-3">Login</button>*/}
                {/*</nav>*/}
            </header>

            <main className="d-flex align-items-center justify-content-between">
                <div className="form-container">
                    <div className="col-md-12" style={{ maxWidth: '500px', maxHeight: '960px' }}>
                        <div className="card border-0 shadow">
                            <div className="card-header bg-primary text-white text-center">
                                <h3>{isLogin ? 'Welcome Back!' : 'New to Sample Tracker? Sign Up'}</h3>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Email address</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        placeholder="Enter email"
                                        onChange={(e) => handleEmailChange(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="password" className="form-label">Password</label>
                                    <input
                                        type="password"
                                        className={`form-control ${passwordError ? 'is-invalid' : ''}`}
                                        id="password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => handlePasswordChange(e.target.value)}
                                        required
                                    />
                                    {passwordError && (
                                        <div className="invalid-feedback">Password should be at least 6 characters.</div>
                                    )}
                                </div>
                                {!isLogin && (
                                    <div className="mb-3">
                                        <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="confirmPassword"
                                            placeholder="Confirm Password"
                                            required
                                        />
                                    </div>
                                )}
                                <div className="d-grid gap-2">
                                    <button
                                        className="btn btn-primary btn-lg"
                                        type="button"
                                        onClick={() => handleProcess()}
                                    >
                                        {isLogin ? 'Sign In' : 'Sign Up'}
                                    </button>
                                </div>
                                {isLoading && (
                                    <div className="d-flex justify-content-center mt-3">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                                {errorMessage && (
                                    <div className="alert alert-danger mt-3" role="alert">
                                        {errorMessage}
                                    </div>
                                )}
                                <p className="mt-3 text-center">
                                    {isLogin ? "Don't have an account? " : 'Already have an account? '}
                                    <button className="btn btn-link text-primary" onClick={toggleAuthMode}>
                                        {isLogin ? 'Sign Up' : 'Sign In'}
                                    </button>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="image-container">
                    <img src="/banner.png" alt="Books" className="main-image" />
                </div>
            </main>
            <footer className="footer-container">

            </footer>
        </div>
    );
};

export default AuthForm;
